<script>
import 'bulma/css/bulma.css'
import { getNotificationData } from '@/api/NotificationUtilities.js'
import notifiedCard from './NotifiedCard'

export default {
  components: {notifiedCard},
  props: ['notificationData'],
  data () {
    return {
      hasNotifications: false,
      notifiedLength: 0,
      isUpdated: false
    }
  },
  async created () {
    // 通知の数値系情報の取得
    ;[this.notifiedLength, this.hasNotifications] = getNotificationData(this.notificationData)
  },
  methods: {
    decreaseLength (flag) {
      if (flag) {
        this.notifiedLength -= 1
      }
      if (this.notifiedLength < 0) {
        this.notifiedLength = 0
      }
      this.hasNotifications = this.notifiedLength > 0
    },
    cancelNotifiedBar () {
      this.$emit('cancelNotifiedBar', false)
    }
  },
  watch: {
    notificationData: function () {
      // 通知の数値系情報の取得
      ;[this.notifiedLength, this.hasNotifications] = getNotificationData(this.notificationData)
    }
  }
}
</script>
<style scoped>
</style>
<template>
  <div class="notified-column">
    <div class="columns is-multiline is-mobile is-marginless">
      <div class="column is-paddingless is-half has-text-left" v-if="notifiedLength == 0">
        <span class="text has-text-weight-bold">通知</span>
        <span class="icon">
          <i class="fa-solid fa-bell"></i>
        </span>
      </div>
      <div class="column is-paddingless is-half has-text-left" v-else-if="notifiedLength> 0">
        <span class="text has-text-weight-bold">通知</span>
        <span v-bind:class="{'has-text-link' : !hasNotifications, 'has-text-danger' : hasNotifications}">
          <span class="icon">
            <i class="fa-solid fa-bell"></i>
          </span>
          <span>
            {{notifiedLength}}
          </span>
        </span>
      </div>
      <div class="column is-paddingless is-half has-text-right">
        <button class="delete" @click="cancelNotifiedBar"></button>
      </div>
    </div>
    <div class="notifiedcard">
      <notifiedCard
        v-for="(data, index) in notificationData"
        v-bind:data="data"
        v-bind:key="index"
        @decreaseNotifiedCount="decreaseLength"
      />
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// src/components/globals/notifiedbar/NotifiedBar.vue